import React, { useState, useEffect, useMemo } from 'react'
import lodash from 'lodash'
import styled from 'styled-components'

const Wrapper = styled.div``

const DebugTime = (props) => {
  const { data } = props

  return <Wrapper>{JSON.stringify(data, 0, 2)}</Wrapper>
}

export default DebugTime
